'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

exports.def = def;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function def(target, key, value, canSet) {
    var val = value;

    var definition = {
        get: function get() {
            return val;
        }
    };

    if (canSet) {
        definition.set = function set(newVal) {
            var oldVal = val;
            val = newVal;
            if (typeof canSet === 'function') {
                canSet(newVal, oldVal);
            }
        };
    }

    (0, _defineProperty2.default)(target, key, definition);

    if (typeof canSet === 'function') {
        canSet(val);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/libs/state/common.js
// module id = nlr4
// module chunks = 1